export interface QuestionTranslation {
    id: number | string;
    question: string;
    subject: string;
    chapter: string;
    answer?: string;
    subject_id?: number | string;
    chapter_id?: number | string;
    complexity_id?: number;
    questionType_id?: number;
    hasAnswerKey?: string;
    answerKey?: string;
}

export class LatestNewQuestionModel {
    id: number;
    qno: string;
    refNo: number;
    refYear: string;
    marks: number;
    className: string;
    language: string;
    isActive: boolean;
    status: string;
    topic: string;
    difficulty: string;
    complexity: string;
    cognitive: string;
    createdAt: Date;
    updatedAt: Date;
    ability: number;
    abilityType: number;
    questionType: number;
    hasStimulus: string;
    estimatedTime: number;
    competencyCode: number;
    class_id: number;
    subject_id: number;
    chapter_id: number;
    classId: number;
    subjectId: number;
    chapterId: number;
    question: string;
    subject: string;
    chapter: string;
    hasAnswerKey?: string;
    answerKey?: string;
    
    // Generic translations map: langName -> Translation
    translations: Record<string, QuestionTranslation>;
    complexity_id: number;
    questionType_id: number;
    preparedBy?: string;
    mobileNo?: string;
    preparedDate?: Date;
    previousAppearanceCount?: number;
    approvalStatus?: string;
    approvedBy?: string;
    approvedDate?: Date;

    constructor(data: Partial<LatestNewQuestionModel> = {}) {
        this.id = data.id || 0;
        this.preparedBy = data.preparedBy || '';
        this.mobileNo = data.mobileNo || '';
        this.qno = data.qno || '';
        this.refNo = data.refNo ?? null;
        this.refYear = data.refYear || '';
        this.marks = data.marks || 0;
        this.className = data.className || '';
        this.language = data.language || 'ENGLISH';
        this.isActive = Boolean(data.isActive);
        this.status = data.isActive ? 'Active' : 'Inactive';
        this.topic = data.topic || '';
        this.difficulty = data.difficulty || '';
        this.complexity = data.complexity || '';
        this.cognitive = data.cognitive || '';
        this.createdAt = data.createdAt || new Date();
        this.updatedAt = data.updatedAt || new Date();
        this.ability = data.ability || null;
        this.abilityType = data.abilityType || null;
        this.questionType = data.questionType || null;
        this.hasStimulus = data.hasStimulus || '';
        this.estimatedTime = data.estimatedTime || null;
        this.competencyCode = data.competencyCode || null;
        this.class_id = data.class_id || data.classId || 0;
        this.subject_id = data.subject_id || data.subjectId || 0;
        this.chapter_id = data.chapter_id || data.chapterId || 0;
        this.classId = data.class_id || data.classId || 0;
        this.subjectId = data.subject_id || data.subjectId || 0;
        this.chapterId = data.chapter_id || data.chapterId || 0;
        this.question = data.question || '';
        this.subject = data.subject || '';
        this.chapter = data.chapter || '';
        this.hasAnswerKey = data.hasAnswerKey || 'No';
        this.answerKey = data.answerKey || '';
        this.translations = data.translations || {};
        this.complexity_id = data.complexity_id || 0;
        this.questionType_id = data.questionType_id || 0;
        this.approvalStatus = data.approvalStatus || 'PENDING';
        this.approvedBy = data.approvedBy || '';
        this.approvedDate = data.approvedDate || null;
        this.preparedDate = data.preparedDate || null;
        this.previousAppearanceCount = data.previousAppearanceCount ?? 0;
    }
}